import { Link } from 'react-router-dom';
import {
    Dialog,
    DialogContent,
    DialogFooter,
    DialogTitle,
} from '../../../../../ui/feedback/Dialog';
import { Button } from '../../../../../ui/input/Button';
import { Typography } from '../../../../../ui/typography/Typography';
import { useBackButton } from '../../../../../utils/useBackButton';
import { useTranslation } from '../../../../../utils/useTranslation';
import { CATALOG_URL, LEARN_MORE_URL } from './constants';
import { AdvertisingCatalogInfoDialogProps } from './types';

export const AdvertisingCatalogInfoDialog: React.FC<AdvertisingCatalogInfoDialogProps> = ({
    title,
    children,
}) => {
    const t = useTranslation();

    const onNavigateBack = useBackButton(CATALOG_URL);

    return (
        <Dialog onClose={onNavigateBack}>
            <DialogTitle onClose={onNavigateBack} withBorderBottom={false}>
                <Typography variant="title3" weight="medium">
                    {title}
                </Typography>
            </DialogTitle>
            <DialogContent p={0}>{children}</DialogContent>
            <DialogFooter withBorderTop={false}>
                <Button
                    size="l"
                    color="secondary"
                    width="100%"
                    as={Link}
                    to={LEARN_MORE_URL}
                    target="_blank"
                >
                    {t('Подробнее')}
                </Button>
            </DialogFooter>
        </Dialog>
    );
};
